import apiClient from '@/shared/api/client';

export type ActivityEventType =
  | 'LOGIN'
  | 'PAGE_VIEW'
  | 'COURSE_VIEW'
  | 'LESSON_VIEW'
  | 'CONTENT_PLAY_START'
  | 'CONTENT_WATCHED'
  | 'QUIZ_SUBMIT'
  | 'CERTIFICATE_DOWNLOAD';

interface TrackContext {
  courseId?: number | null;
  contentId?: number | null;
  path?: string | null;
  metadata?: Record<string, unknown>;
}

const SESSION_KEY = 'analytics.sessionId';

const getSessionId = (): string => {
  try {
    const existing = sessionStorage.getItem(SESSION_KEY);
    if (existing) return existing;
    const id =
      typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : `sess-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(SESSION_KEY, id);
    return id;
  } catch {
    return `sess-${Date.now()}`;
  }
};

const isAuthenticated = (): boolean => {
  try {
    return Boolean(localStorage.getItem('token'));
  } catch {
    return false;
  }
};

export const trackEvent = (eventType: ActivityEventType, ctx: TrackContext = {}): void => {
  if (!isAuthenticated()) return;
  const body = {
    eventType,
    sessionId: getSessionId(),
    path: ctx.path ?? (typeof window !== 'undefined' ? window.location.pathname : null),
    courseId: ctx.courseId ?? null,
    contentId: ctx.contentId ?? null,
    metadata: ctx.metadata ? JSON.stringify(ctx.metadata) : null,
  };
  apiClient.post('/learning/activity', body).catch(() => {
    /* fire-and-forget */
  });
};
